import classNames from "classnames";
import { Container, Heading5, OrderedList } from "shared/components";

import styles from "./Content038.module.scss";

export const Content038 = ({ payload }) => {
  const title = payload?.title ?? "";
  const list = payload?.list ?? [];
  const template = payload?.template ?? "light";

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container>
        <div className={styles.block}>
          <Heading5 className={styles.title}>{title}</Heading5>

          <div className={styles.content}>
            <OrderedList
              items={list}
              appearance="bold"
              className={styles.list}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content038;
